var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightChemicalInjection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M16.53,9.4v7.72H3.47V9.4h0.01c0.16,3.42,2.94,6.14,6.38,6.2c0.05,0.01,0.09,0.01,0.14,0.01c3.5,0,6.36-2.75,6.52-6.21H16.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M9.86,2.57V15.6 c-3.44-0.06-6.22-2.78-6.38-6.2C3.47,9.29,3.47,9.19,3.47,9.08C3.47,5.53,6.31,2.64,9.86,2.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M16.53,9.08 c0,0.11,0,0.21-0.01,0.32c-0.16,3.46-3.02,6.21-6.52,6.21c-0.05,0-0.09,0-0.14-0.01V2.57C9.91,2.56,9.95,2.56,10,2.56 C13.61,2.56,16.53,5.48,16.53,9.08z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 6.148,
    y1: 17.121,
    x2: 6.148,
    y2: 19.159
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 13.852,
    y1: 17.121,
    x2: 13.852,
    y2: 19.159
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 9.86,
    y1: 16.56,
    x2: 9.86,
    y2: 15.6
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    points: "9.86,2.57  9.86,1.6 9.86,0.84  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 11.512,
    y1: 1.597,
    x2: 8.215,
    y2: 1.597
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightChemicalInjection);
export default __webpack_public_path__ + "static/media/light-chemical-injection.c85cc51e3a91b124ce090ca1df7a4e6d.svg";
export { ForwardRef as ReactComponent };